export function renderContent() {
    return (
        <div style={{ minHeight: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '28px', marginBottom: '15px' }}>
                <span id="swal-status-message" style={{ fontFamily: 'Roboto,Helvetica,Arial,sans-serif', fontSize: '16px' }}>
                    Preparing...
                </span>
            </div>
            <div style={{ width: '100%', marginBottom: '15px' }}>
                <progress id="swal-progress-bar" value={0} max={100} style={{ width: "100%", height: "20px" }} />
            </div>
            <div style={{ height: '20px' }}>
                <span id="swal-progress-percent" style={{ fontFamily: 'Roboto,Helvetica,Arial,sans-serif', fontSize: '16px' }}>
                    0%
                </span>
            </div>
        </div>
    );
}

export function updateProgressUI(stage, current, total, percent = 0) {
    const messageEl = document.getElementById('swal-status-message');
    const barEl = document.getElementById('swal-progress-bar');
    const percentEl = document.getElementById('swal-progress-percent');

    let message = stage === 'compressing' ? `Optimizing photos (${current} of ${total})...` : percent >= 100 ? `Finalising submission...` : `Uploading to server...`;
    let barValue = stage === 'compressing' ? (total > 0 ? Math.round((current / total) * 100) : 0) : percent;

    if (messageEl) messageEl.innerText = message;

    if (barEl) {
        if (stage === 'uploading' && percent >= 100) {
            // Removing the value attribute turns it into a native animated loading bar
            barEl.removeAttribute('value');
        } else {
            barEl.value = barValue;
        }
    }

    if (percentEl) {
        percentEl.innerText = (stage === 'uploading' && percent >= 100) ? '' : `${barValue}%`;
    }
};